module.exports = __webpack_public_path__ + "img/mikepaper4@2x.4295af5d.jpg";